import styled from 'styled-components';
import { Menu } from 'antd';

export const NavigationMenuStyled = styled(Menu)`
  &.ant-menu {
    min-width: 15rem;
    line-height: 3.75rem;
    border-bottom-color: transparent;
    background: transparent;
  }
`;
